import axios from 'axios'

const baseURL = window?.location?.origin || process.env.REACT_APP_ENDPOINT_EVENTS

const endpoints = {
  events: baseURL + '/bin/events.json'
}

export const events = () => {
  return axios.get(endpoints.events)
}

export default endpoints
